export default class OpsStringUtils {
  public static capitalize = (str: string) => {
    const lower = str.toLowerCase();
    return str.charAt(0).toUpperCase() + lower.slice(1).replace("_", " ");
  };

  public static handlePlural = (instance: number, message: string) => {
    if (instance === 1) {
      return message.slice(0, -1);
    }
    return message;
  };

  public static lowerStrUpperFirstLetter = (str: string) => {
    let words = str.toLowerCase().split("_");

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
    }
    let convertedStr = words.join(" ");
    return convertedStr;
  };
}
